import ServiceCRUD from '../../../services/ServiceCRUDSCALE';

class TimeShiftService extends ServiceCRUD {
  constructor() {
    super('/api/time-shift');
  }
}

export default new TimeShiftService();
